import React, { useEffect, useState } from 'react';

const TipSelection = ({ mpesaRequestData, setMpesaRequestData }) => {
  const { amount, currency } = mpesaRequestData
  const [selectedTip, setSelectedTip] = useState(amount || null);
  const [customTip, setCustomTip] = useState('');

  const tipOptions = [
    { value: '100', label: '100' },
    { value: '200', label: '200' },
    { value: '300', label: '300' },
    { value: '400', label: '400' },
    { value: '500', label: '500' },
  ];

  const handleTipSelection = (value) => {
    setSelectedTip(value);
    setCustomTip('');
    setMpesaRequestData((prevState) => ({
      ...prevState, amount: value
    }))
  };

  const handleCustomTipChange = (e) => {
    const value = e.target.value;
    setCustomTip(value);
    if (value && !isNaN(value)) {
      setSelectedTip(value);
      setMpesaRequestData((prevState) => ({
        ...prevState, amount: value
      }))
    } else {
      setSelectedTip(null);
      setMpesaRequestData((prevState) => ({
        ...prevState, amount: ''
      }))
    }
  };

  useEffect(() => {
    if (amount) {
      setSelectedTip(amount)
      if (!tipOptions.some(option => option.value === amount)) {
        setCustomTip(amount);
      }
    }
  }, [amount])

  return (
    <div className="mb-4">
      <label className="block font-medium text-gray-700 mb-2">Tip Amount ({currency})</label>
      <div className="flex flex-wrap gap-2">
        {tipOptions.map((option) => (
          <div
            key={option.value}
            className={`px-4 py-2 rounded-lg cursor-pointer ${selectedTip === option.value
              ? 'border-2 border-[#e9b22c] bg-white'
              : 'bg-white border border-gray-200 text-gray-700 hover:bg-gray-100'
              }`}
            onClick={() => handleTipSelection(option.value)}
          >
            {option.label}
          </div>
        ))}
        <div className="flex-grow">
          <label htmlFor="custom-tip" className="block text-sm font-medium text-gray-700 mb-1">
            Or enter custom amount:
          </label>
          <div className={`flex gap-2 items-center ${selectedTip && !tipOptions.some(option => option.value === selectedTip) ? 'border-2 border-[#e9b22c]' : 'border border-gray-200'} rounded-lg`}>
            <span className="px-3 text-gray-500 border-r">{currency}</span>
            <input
              id="custom-tip"
              type="number"
              value={customTip}
              onChange={handleCustomTipChange}
              placeholder="Custom amount"
              className="w-full px-3 py-2 rounded-lg focus:outline-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipSelection